export default "__VITE_ASSET__BINFyOO0__"